const sliderImages = [
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: "https://i.imgur.com/m8uZSWl.jpg",
  },
  {
    title: "Second Slide",
    description: "This is the first slider Image of our carousel",
    urls: "https://i.imgur.com/QYrpO6V.jpg",
  },
  {
    title: "Third Slide",
    description: "This is the second slider Image of our carousel",
    urls: "https://i.imgur.com/8vKD0YM.jpg",
  },
  {
    title: "Fourth Slide",
    description: "This is the Third slider Image of our carousel",
    urls: "https://imgur.com/oGejENm.jpg",
  },
  {
    title: "Fifth Slide",
    description: "This is the Fourth slider Image of our carousel",
    urls: "https://imgur.com/ENj0PJs.jpg",
  },
  {
    title: "Sixth Slide",
    description: "This is the Fifth slider Image of our carousel",
    urls: "https://imgur.com/BXs5gjo.jpg",
  },
];

export default sliderImages
